import Base from './Base';
import Invite from '../models/Invite';

export default class Invites extends Base {
    get models() {
        const collection = this.data.map(item => new Invite(item));
        collection.collection = this;

        return collection;
    }
}
